'use strict';
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNote$0024 from "./app.data.data_point_types$package$-Document-Note$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$() {
  this.aIL = null;
  this.aJ2 = null;
  this.aIO = null;
  this.aIP = false;
  this.aIU = null;
  this.aIV = false;
  this.aJ0 = null;
  this.aJ1 = false;
  this.aIM = null;
  this.aIN = false;
  this.aIY = null;
  this.aIZ = false;
  this.aIW = null;
  this.aIX = false;
  this.aIQ = null;
  this.aIR = false;
  this.aIS = null;
  this.aIT = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$ = this;
  this.aIL = $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNote$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$();
  this.aJ2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNote$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNote$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$.prototype = $p;
$p.eR = (function() {
  return this.aIL;
});
$p.eO = (function() {
  return this.aJ2;
});
$p.bW = (function() {
  if ((!this.aIP)) {
    this.aIO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aIP = true;
  }
  return this.aIO;
});
$p.b9 = (function() {
  if ((!this.aIV)) {
    this.aIU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aIV = true;
  }
  return this.aIU;
});
$p.b3 = (function() {
  if ((!this.aJ1)) {
    this.aJ0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aJ1 = true;
  }
  return this.aJ0;
});
$p.aG = (function() {
  if ((!this.aIN)) {
    this.aIM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aIN = true;
  }
  return this.aIM;
});
$p.az = (function() {
  if ((!this.aIZ)) {
    this.aIY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aIZ = true;
  }
  return this.aIY;
});
$p.aY = (function() {
  if ((!this.aIX)) {
    this.aIW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aIX = true;
  }
  return this.aIW;
});
$p.asi = (function() {
  if ((!this.aIR)) {
    this.aIQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Document Note";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aIR = true;
  }
  return this.aIQ;
});
$p.bNw = (function() {
  if ((!this.aIT)) {
    this.aIS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().zt;
    this.aIT = true;
  }
  return this.aIS;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$, "app.data.data_point_types$package$DocumentNoteForm$", ({
  FG: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNoteForm$ };
//# sourceMappingURL=app.data.data_point_types$package$-Document-Note-Form$.js.map
